export default __webpack_public_path__ + "static/shopify-bba46c815f44d8c8203039e9935f5d9a.png";